[
  "0.14",
  "0.15",
  "1.0",
  "1.16.201",
  "1.16.210",
  "1.16.220",
  "1.17.0",
  "1.17.10",
  "1.17.30",
  "1.17.40",
  "1.18.0",
  "1.18.11",
  "1.18.30",
  "1.19.1",
  "1.19.10",
  "1.19.20",
  "1.19.21",
  "1.19.30",
  "1.19.40",
  "1.19.50",
  "1.19.60",
  "1.19.62",
  "1.19.63",
  "1.19.70",
  "1.19.80",
  "1.20.0",
  "1.20.10",
  "1.20.15",
  "1.20.30",
  "1.20.40",
  "1.20.50",
  "1.20.61"
]